import { ParseSpec } from 'prosemirror-markdown';

import { BaseExtension } from '@lyearn/lygo-core';

import markdownBreakToParagraphs from '../../rules/breaks';
import { NODE_NAME } from './consts';
import plugins from './plugins';

export default class HardBreak extends BaseExtension {
  get name(): string {
    return NODE_NAME;
  }

  parseMarkdown(): void | ParseSpec {
    return { node: 'br' };
  }

  get markdownToken(): string {
    return 'br';
  }

  get rulePlugins() {
    return [markdownBreakToParagraphs];
  }

  plugins = plugins;
}
